(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/level-indicator.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/level-indicator.js');

'use strict';

svs.numbergames.game.views.LevelIndicator = Marionette.View.extend({
  viewOptions: ['multipliedRowPrice'],
  ui: {
    indicator: '.js-indicator',
    indicatorBase: '.js-indicator-base',
    topWin: '.js-desc-top-win',
    topWinSum: '.js-topWinSum'
  },
  modelEvents: {
    'change:level change:hasKungKeno change:board': 'onChangeLevel'
  },
  className() {
    const brandingSuffix = svs.numbergames.productMapping.getBrandingClass(this.model.get('productId'));
    return "numbergames-level-indicator numbergames-level-indicator-".concat(brandingSuffix);
  },
  template(data) {
    return svs.numbergames.game.templates.level_indicator(data);
  },
  templateContext() {
    const levelTopWin = this.getCurrentTopWin();
    return {
      levelTopWin
    };
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
    this.onResize = this.setIndicatorInnerWidth.bind(this);
    window.addEventListener('resize', this.onResize);
  },
  onDomRefresh() {
    this.onChangeLevel();
    this.setIndicatorInnerWidth();
  },
  onChangeRowPriceMulti(multipliedRowPrice) {
    this.multipliedRowPrice = multipliedRowPrice;
    this.render();
  },
  getCurrentTopWin() {
    const {
      getLevelWinPlanTopWin,
      types
    } = svs.numbergames.rules.utils.keno_winplan;
    const rowPrice = this.multipliedRowPrice;
    const level = this.model.get('level');
    const hasKungKeno = this.model.get('hasKungKeno');
    if (this.model.get('isSystem')) {
      const type = types.KENO_SYSTEM;
      const systemNumbers = this.model.get('numbers').length;
      return getLevelWinPlanTopWin({
        type,
        level,
        systemNumbers,
        rowPrice,
        hasKungKeno
      });
    }
    return getLevelWinPlanTopWin({
      level,
      rowPrice,
      hasKungKeno
    });
  },
  onChangeLevel() {
    const topLevelWin = this.getCurrentTopWin();
    this.updateIndicatorToLevel();
    gsap.to(this.getUI('indicatorBase'), {
      opacity: 1,
      duration: 0.3,
      ease: 'ease:Out'
    });
    if (!topLevelWin) {
      this.getUI('topWin').hide();
    } else {
      this.getUI('topWin').show();
      this.getUI('topWinSum').text(svs.utils.format.Currency(topLevelWin));
    }
  },
  updateIndicatorToLevel() {
    gsap.to(this.getUI('indicator'), {
      width: "".concat(this.calculateLevelToPercent(), "%"),
      duration: 0.5,
      ease: 'ease.inOut'
    });
  },
  calculateLevelToPercent() {
    const maxLevels = this.model.get('isSystem') ? 9 : 11,
      level = this.model.get('level'),
      base = 100 / maxLevels,
      width = base * level;
    if (width > 100) return 100;
    return base * level;
  },
  setIndicatorInnerWidth() {
    this.$('.indicator-inner').width(this.$el.innerWidth());
  },
  onDestroy() {
    window.removeEventListener('resize', this.onResize);
  }
});

 })(window);